import { Component } from 'react';
export default class TimezoneIcon extends Component {
    render() {
        return (
            <svg width="100%" height="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.9999" cy="10.0001" r="8.91176" stroke="#263238"/>
            <path d="M14.794 10.0001C14.794 12.5295 14.2163 14.7948 13.3076 16.4101C12.3902 18.0412 11.201 18.9119 9.99993 18.9119C8.79886 18.9119 7.60966 18.0412 6.69221 16.4101C5.78357 14.7948 5.20581 12.5295 5.20581 10.0001C5.20581 7.47076 5.78357 5.20551 6.69221 3.59015C7.60966 1.95912 8.79886 1.08838 9.99993 1.08838C11.201 1.08838 12.3902 1.95912 13.3076 3.59015C14.2163 5.20551 14.794 7.47076 14.794 10.0001Z" stroke="#263238"/>
            <line x1="10.5" y1="0.588379" x2="10.5" y2="18.8237" stroke="#263238"/>
            <line x1="0.588135" y1="9.5" x2="18.8234" y2="9.5" stroke="#263238"/>
            </svg>

        )
    }
};